'use strict';let

CompatibilityHelpers=class CompatibilityHelpers{
static getInternetExplorerVersion(){

var version=-1;

if(navigator.appName=='Microsoft Internet Explorer'){
var ua=navigator.userAgent;
var re=new RegExp('MSIE ([0-9]{1,}[.0-9]{0,})');
if(re.exec(ua)!=null){
version=parseFloat(RegExp.$1);
}
}

return version;
}

static isMSIE(){
return CompatibilityHelpers.getInternetExplorerVersion()!==-1;
}

static getComponentTypeFromClassName(component){
let componentName=component.prototype.constructor.name;

if(componentName.match(/controller$/i)){
return'controller';
}

if(componentName.match(/directive$/i)){
return'directive';
}

if(componentName.match(/commandfactory|errorhandler[s]{0,1}|service$/i)){
return'service';
}

throw new Error(`Unable to determine type of angular component ${component.prototype.constructor.name}, type=${component.type}.`);
}};


module.exports=CompatibilityHelpers;
//# sourceMappingURL=compatibilityHelpers.js.map
